import {
  Backend,
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import { SupportFeedbackIsAllowedCollection } from './support-feedback-is-allowed.types';

const API_ENDPOINT = 'support/userIsAllowedFeedback.php';

export function supportFeedbackIsAllowedBackend(): Backend<SupportFeedbackIsAllowedCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query, order) => ({
      endpoint: API_ENDPOINT,
      isGaf: true,
      params: {
        date_resolved: getQueryParamValue(query, 'dateResolved')[0] / 1000,
        support_ticket_id: getQueryParamValue(query, 'supportTicketId')[0],
      },
    }),
    push: undefined,
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
